import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import { useFormContext } from 'react-hook-form'
import { IconButton, SvgIcon, Badge, Tooltip } from '@mui/material'
import { ReactComponent as CalendarWeek } from 'assets/CalendarWeek.svg'

import { get } from 'utils/lodash'

import EventBlocker from 'components/common/EventBlocker'
import FilterMenuField from '../common/FilterMenuField'
import { isSameAction } from '../utils'

const BUTTON_CLASS_NAME = 'wo-service-filter'

const FiltersMenuButton = ({ sx }) => {
  const { control, watch, setValue } = useFormContext()
  const searchServicesInput = watch('searchServicesInput')
  const servicesOptions = watch('servicesOptions')
  const selectedServices = watch('selectedServices')
  const selectedCount = useMemo(() => get(selectedServices, 'length', 0), [selectedServices])
  const [anchorEl, setAnchorEl] = useState(null)

  const handleServicesSearchInputChange = (_, value, reason) => {
    if (reason !== 'reset') {
      setValue('searchServicesInput', value)
    }
  }

  const handleClose = event => {
    if (isSameAction(event, BUTTON_CLASS_NAME)) {
      return
    }
    setAnchorEl(null)
  }

  const handleClick = event => {
    event.stopPropagation()
    if (anchorEl) {
      handleClose()
      return
    }
    setAnchorEl(event.currentTarget)
  }

  const isOpen = Boolean(anchorEl)

  return (
    <EventBlocker>
      <Tooltip title="Services" arrow placement="top">
        <IconButton className={BUTTON_CLASS_NAME} sx={sx} onClick={handleClick}>
          <Badge badgeContent={selectedCount} color="primary">
            <SvgIcon>
              <CalendarWeek color="primary" />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>
      {isOpen && (
        <FilterMenuField
          control={control}
          anchorEl={anchorEl}
          name="selectedServices"
          label="Services"
          inputValue={searchServicesInput}
          onInputChange={handleServicesSearchInputChange}
          options={servicesOptions}
          onClose={handleClose}
          width={250}
          boxRestProps={{ right: 100 }}
        />
      )}
    </EventBlocker>
  )
}

FiltersMenuButton.propTypes = {
  sx: PropTypes.object,
}

export default FiltersMenuButton
